/**
 * Невозможно чтобы не скакал скролл при открытии модалок и меню.
 * Любые попытки обречены на провал. испробована куча всего.
 */
export default {
  body: document.querySelector('body'),
  lock() {
    this.body.style.overflow = 'hidden';
  },
  unlock(){
    this.body.style.overflow = '';
  }
}



// WEBPACK FOOTER //
// ./src/JE/bodyLocker.js